import { LabelFilter } from "../../components/translation/statistics/TranslationStats";
import { TranslationStatus } from "../../model/Translation";

export const getTranslationStatusColor = (value: string) => {
  return TranslationStatus.EXTRACTED === value ||
    TranslationStatus.REVIEW_COMPLETED === value ||
    TranslationStatus.INTEGRATED === value
    ? "text-green-500"
    : TranslationStatus.REVIEW_REJECTED === value ||
      TranslationStatus.EXTRACTION_FAILED === value ||
      TranslationStatus.INTEGRATION_FAILED === value
    ? "text-red-500"
    : TranslationStatus.IN_REVIEW === value ||
      TranslationStatus.IN_TRANSLATION === value ||
      TranslationStatus.EXTRACTION_RUNNING === value ||
      TranslationStatus.INTEGRATION_RUNNING === value
    ? "text-blue-500"
    : "text-grey-500";
};

export const transformQuarterCodes = (input: string) => {
  if (!input) {
    return;
  }
  const num = parseInt(input.trim(), 10);
  const year = 2000 + Math.floor(num / 10);
  const quarter = `Q${num % 10}`;
  return `${year} ${quarter}`;
};

export const formatDateToDDMMYYYYHHmm = (date: Date) => {
  const pad = (n: number): string => (n < 10 ? "0" + n : n.toString());

  const day = pad(date.getDate());
  const month = pad(date.getMonth() + 1);
  const year = date.getFullYear();

  const hours = pad(date.getHours());
  const minutes = pad(date.getMinutes());

  return `${day}/${month}/${year} ${hours}:${minutes}`;
};

/**
 *
 * @param translationProduct string that is either 5 or 9
 * @returns functionnal name of the product based on its number
 */
export const getsylobProduct = (translationProduct: string) => {
  if (!translationProduct) {
    return "";
  }
  const result = translationProduct === "5" ? "Fortee" : "Sylob9";
  return result;
};

export const removeSnapshotIfExists = (translationMavenVersion: string) => {
  if (!translationMavenVersion) {
    return;
  }
  let mavenVersion = translationMavenVersion.toLowerCase();
  let exists = mavenVersion.includes("-snapshot");
  let index = mavenVersion.indexOf("-");
  return exists ? translationMavenVersion.substring(0, index) : translationMavenVersion;
};

export const getButtonStyles = (
  filter: LabelFilter,
  activeFilter: LabelFilter,
  colorType: "teal" | "green" | "yellow" | "purple"
) => {
  const isActive = activeFilter === filter;
  const baseStyles =
    "flex items-center justify-center px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 focus:outline-none";

  if (isActive) {
    switch (colorType) {
      case "teal":
        return `${baseStyles} bg-teal-100 text-teal-800 border border-teal-300 shadow-sm ring-2 ring-teal-200`;
      case "green":
        return `${baseStyles} bg-green-100 text-green-800 border border-green-300 shadow-sm ring-2 ring-green-200`;
      case "yellow":
        return `${baseStyles} bg-yellow-100 text-yellow-800 border border-yellow-300 shadow-sm ring-2 ring-yellow-200`;
      case "purple":
        return `${baseStyles} bg-purple-100 text-purple-800 border border-purple-300 shadow-sm ring-2 ring-purple-200`;
      default:
        return `${baseStyles} bg-gray-100 text-gray-800 border border-gray-300 shadow-sm ring-2 ring-gray-200`;
    }
  }

  // Non-active: very light, no ring, muted border, softer text
  switch (colorType) {
    case "teal":
      return `${baseStyles} bg-teal-50 text-teal-500 hover:bg-teal-100 border border-teal-100`;
    case "green":
      return `${baseStyles} bg-green-50 text-green-500 hover:bg-green-100 border border-green-100`;
    case "yellow":
      return `${baseStyles} bg-yellow-50 text-yellow-600 hover:bg-yellow-100 border border-yellow-100`;
    case "purple":
      return `${baseStyles} bg-purple-50 text-purple-600 hover:bg-purple-100 border border-purple-100`;
    default:
      return `${baseStyles} bg-gray-50 text-gray-500 hover:bg-gray-100 border border-gray-100`;
  }
};

export const ALLOWED_REVIEW_TRANSLATION_STATUS = [
  TranslationStatus.EXTRACTED,
  TranslationStatus.IN_TRANSLATION,
  TranslationStatus.REVIEW_REJECTED,
];
